export function hasAddon(props) {
    return !!(props.addonBefore || props.addonAfter);
}
export function hasPrefixSuffix(props) {
    return !!(props.prefix || props.suffix || props.allowClear);
}
//# sourceMappingURL=utils.js.map